import { makeStyles } from '@material-ui/core/styles';
import colors from '@danfoss/webex-ui/dist/styles/_colors.scss';

export const useStyles = makeStyles(theme => ({
  errorMessage: {
    color: colors.webexuiRedStrong,
    fontWeight: 'bold',
  },
  form: {
    marginTop: 4,
  },
  buttonsSection: {
    margin: '32px 0 10px 3px'
  },
  buttonMargin: {
    [theme.breakpoints.only('xs')]: {
      margin: '20px 0 0',
    },
    [theme.breakpoints.up('sm')]: {
      marginLeft: '15px',
    }
  },
  groupContainer: {
    padding: 0
  }
}));
